import { ManageState } from '../../schemas/manage/manage.Schema';
import * as Constants from '../../utils/constants';
import produce from 'immer';

export const initialState: ManageState = {
  capacityToSeeResult: {
    data:{  
      loadCount: 0,    
      loadPostings:[]
    },
    hideSeeResult:false
  },
  capacityLoad: {
    capacity: { loadCount: 0 },
    loadPostings: [],
  },
  profileImg: [],
  manageCardData: [],
  countryCodes: [],
  users: {
    data: [],
    loaded: false,
    selectedProfile: null,
    filter: {
      selected: [],
      direction: "desc",
    },
    validateUser: {
      isUserValid: null,
      details: {},
    },
    transfer: {
      isRequested: false,
      details: {},
    },
  },
  capacity: {
    loaded: false,
    data: [],
    filter: {
      selected: [],
      direction: "desc",
    },
    selected: null,
    totalPages : 0,
    remainingRecords:0
  },
  carrierProfile: {
    data: null,
    loaded: false,
  },
  manageSegmentSelected: "ALL"
};

export default (state = initialState, action: any) =>
  produce(state, (draft) => {
    switch (action.type) {
      case Constants.SET_CAPACITY_TO_SEE_RESULT:
        draft.capacityToSeeResult = action.payload;
        break;
      case Constants.GET_MANAGE_CARD_DATA:
        draft.manageCardData = action.payload;
        break;
      case Constants.MANAGE_USERS_LIST_SUCCESS:
        draft.users.data = action.payload.usersList;
        draft.users.loaded = true;
        draft.users.selectedProfile = null;
        draft.users.validateUser.isUserValid = null;
        break;
      case Constants.ASSIGN_DRIVER_LIST:
        draft.users.validateUser.isUserValid = null;
        break
      case Constants.MANAGE_USER_SELECTED:
        draft.users.selectedProfile = action.payload.userProfile;
        break;
      case Constants.MANAGE_USER_FILTER:
        draft.users.filter = action.payload.filter;
        break;
      case Constants.MANAGE_USER_VALIDATE_STATUS:
        draft.users.validateUser = action.payload;
        break;
      case Constants.MANAGE_USER_VALIDATE_RESET:
        draft.users.validateUser = {
          isUserValid: null,
          details: {},
        };
        break;
      case Constants.MANAGE_USER_ADD_SUCCESS:
        draft.users.data = [...draft.users.data, action.payload.member];
        draft.users.filter = initialState.users.filter;
        draft.users.selectedProfile = null;
        break;
      case Constants.MANAGE_USER_EDIT_SUCCESS:
        const { member } = action.payload;
        draft.users.data = draft.users.data.map((item: any) =>
          getDraftUserPrincipalName(item, member)
        );
        draft.users.selectedProfile = member;
        break;
      case Constants.MANAGE_USER_TRANSFER_REQUEST:
        draft.users.transfer = action.payload.transfer;
        break;
      case Constants.MANAGE_USER_TRANSFER_REQUEST_RESET:
        draft.users.transfer = {
          isRequested: false,
          details: {},
        };
        break;
      case Constants.MANAGE_USER_REMOVE_SUCCESS:
        draft.users.data = draft.users.data.filter(
          (user: any) => user.userPrincipalName !== action.payload.userId
        );
        draft.users.selectedProfile = null;
        break;
      case Constants.MANAGE_USER_LOADED_RESET:
        draft.users.loaded = false;
        break;
      case Constants.MANAGE_CAPACITY_FILTER:
        draft.capacity.filter = action.payload.filter;
        break;
      case Constants.MANAGE_CAPACITY_ADD_SUCCESS:
        draft.capacity.data = [
          action.payload.capacityItem,
          ...draft.capacity.data
        ];
        draft.capacity.filter = initialState.capacity.filter;
        break;
      case Constants.MANAGE_CAPACITY_EDIT_SUCCESS:
        const { capacityItem } = action.payload;
        draft.capacity.data = draft.capacity.data.map((item: any) =>
          draftCapacityData(item, capacityItem)
        );
        draft.capacity.selected = capacityItem;
        break;

      case Constants.MANAGE_CAPACITY_SELECTED:
        draft.capacity.selected = action.payload.capacityItem;
        break;
      case Constants.REMOVE_MANAGE_CAPACITY_LOADS_RESULTS:
        const removedLoad = actionPayloadValidationforRemovedLoad(action);
       
        if(removedLoad){
          removedCapacityLoad(draft,removedLoad);
        }
        break;
      case Constants.GET_CAPACITY_LOADS_SUCCESS:
        const { data, data: { capacity, loadPostings } = { capacity: { loadCount: 0 }, loadPostings: [] }, isPagination } = action.payload;
        draft.capacityLoad.capacity = capacity;
        draft.capacityLoad.loadPostings = isPagination ? draft.capacityLoad.loadPostings.concat(loadPostings) : loadPostings;
        draft.capacity.data = getUpdatedCapacityArray(draft,capacity); 
        if(capacity.capacityId === draft.capacityToSeeResult.data.capacityId) { draft.capacityToSeeResult.data.loadPostings = isPagination ? draft.capacityToSeeResult.data.loadPostings.concat(loadPostings) : loadPostings }
        draft.capacityToSeeResult.data.loadCount = capacity.loadCount;
        break;
      case Constants.MANAGE_CAPACITY_LIST_SUCCESS:
        const items = action.payload.isRefresh
          ? action.payload.capacityList
          : [...draft.capacity.data, ...action.payload.capacityList];
        draft.capacity.data = items.filter((item: any, index: number) => {
          const findIndex = items.findIndex(
            (newItem: any) => newItem.capacityId === item.capacityId
          );
          return index === findIndex;
        });
        draft.capacity.data = getUpdatedCapacityData(draft); 
        draft.capacity.selected = null;
        draft.capacity.loaded = true;
        draft.capacity.totalPages = getTotalPages(action);
        draft.capacity.remainingRecords = getRemainingRecords(action,draft);
        break;
      case Constants.MANAGE_CAPACITY_REMOVE_SUCCESS:
        draft.capacity.data = draft.capacity.data.filter(
          (details) => details.capacityId !== (action.payload as any).capacityId
        );
        break;
      case Constants.CARRIER_MANAGE_DATA_SUCCESS:
        draft.carrierProfile.data = (action.payload as any).data;
        draft.carrierProfile.loaded = true;
        break;
      case Constants.LOAD_STATE_COUNTRY_CODES: 
        const { response } = getResponse(action);
        draft.countryCodes = response.countries;
        break;
      case Constants.STORE_SEGMENT_SELECTED: {
        draft.manageSegmentSelected = action?.payload;
      }
    }
  });
  function getResponse(action:any){
    return action.payload && (action.payload as any);
  }
  function getRemainingRecords(action:any, draft:any){
  return action.payload.totalRecords - draft.capacity.data.length || 0;
  }
function getTotalPages(action: any): number | null {
  return action.payload.totalPages - 1 || 0;
}

  function getUpdatedCapacityData(draft:any){
   return draft.capacity.data.map((details:any)=>{
    return {...details, loadPostings:details.loadPostings || [],isLoadCountAvailable:details.isLoadCountAvailable || false}
  });
}
  function getUpdatedCapacityArray(draft:any,capacity:any){
   return  draft.capacity.data.map((details: any) => details.capacityId === capacity.capacityId ? {...draft.capacityLoad.capacity,loadPostings:draft.capacityLoad.loadPostings,isLoadCountAvailable:true} : details);
  }
function removedCapacityLoad(draft: any, removedLoad: any) {
  draft.capacityToSeeResult.data.loadPostings = draft.capacityToSeeResult.data.loadPostings.filter(
    (details: any) => details.loadId !== removedLoad
  );
  draft.capacityLoad.loadPostings = draft.capacityLoad.loadPostings.filter(
    (details: any) => details.loadId !== removedLoad
  );
  draft.capacityToSeeResult.data.loadCount = draft.capacityToSeeResult.data.loadCount - 1;
}
function getDraftUserPrincipalName(item: any, member: any): any {
  return item.userPrincipalName === member.userPrincipalName ? member : item;
}

function draftCapacityData(item: any, capacityItem: any): any {
  return item.capacityId === capacityItem.capacityId ? capacityItem : item;
}

function actionPayloadValidationforRemovedLoad(action: any) {
  return action.payload && (action.payload as any);
}

